import { AxiosRequestConfig } from 'axios';

import { apiClient } from '@/lib/api/client';
import { PaginatedResponse } from '@/lib/api/types';
import { PaginationSearchParamsType } from '@/lib/utils/pagination';

import {
  AuthResponse,
  AvailabilityCheckResponse,
  SignInFields,
  SignUpFields,
  User,
} from '../types';

/**
 * Method to sign in a user
 */
export const postSignIn = async (
  data: SignInFields,
  options?: AxiosRequestConfig,
) => {
  return apiClient<AuthResponse>(
    {
      url: '/auth/login',
      method: 'POST',
      data,
    },
    options,
  );
};

/**
 * Method to sign up a user
 */
export const postSignUp = async (
  data: SignUpFields,
  options?: AxiosRequestConfig,
) => {
  return apiClient<AuthResponse>(
    {
      url: '/auth/signup',
      method: 'POST',
      data,
    },
    options,
  );
};

/**
 * Method to check if a username is available
 */
export const getUsernameAvailable = async (
  username: string,
  options?: AxiosRequestConfig,
) => {
  return apiClient<AvailabilityCheckResponse>(
    {
      url: `/users/username/available?username=${encodeURIComponent(username)}`,
      method: 'GET',
    },
    options,
  );
};

/**
 * Method to check if an email is available
 */
export const getEmailAvailable = async (
  email: string,
  options?: AxiosRequestConfig,
) => {
  return apiClient<AvailabilityCheckResponse>(
    {
      url: `/users/email/available?email=${encodeURIComponent(email)}`,
      method: 'GET',
    },
    options,
  );
};

export const getCurrentUser = async (options?: AxiosRequestConfig) => {
  return apiClient<User>(
    {
      url: '/auth/me',
      method: 'GET',
    },
    options,
  );
};

export const forgotPassword = async (
  email: string,
  options?: AxiosRequestConfig,
) => {
  return apiClient(
    {
      url: '/auth/forgot-password',
      method: 'POST',
      data: {
        email,
      },
    },
    options,
  );
};

export const resetPassword = async (
  data: {
    password: string;
    passwordConfirmation: string;
    token: string;
  },
  options?: AxiosRequestConfig,
) => {
  return apiClient(
    {
      url: '/auth/reset-password',
      method: 'POST',
      data,
    },
    options,
  );
};

export const getUsers = (params: PaginationSearchParamsType) => {
  return apiClient<PaginatedResponse<User>>({
    url: '/admin/users',
    method: 'GET',
    params,
  });
};
